import type { UserListFilter } from '../../../lib/core/definitions'

const getUserListFilter = (): UserListFilter => ({
  orderBy: 'fullName',
})

export default getUserListFilter
